import { API, CustomAxiosConfig } from './types'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Dock } from '../../api/models'

export class DockAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}) => {
    const response = await this.api.get('/logistics/docks', config)
    response.data = paginatedTransform(Dock)(response.data)
    return response.data
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Dock> => {
    const response = await this.api.get(`/logistics/docks/${guid}`, config)
    return rawTransform(Dock)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Dock> => {
    const response = await this.api.post('/logistics/docks', data, config)
    return rawTransform(Dock)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Dock> => {
    const response = await this.api.patch(`/logistics/docks/${guid}`, data, config)
    return rawTransform(Dock)(response.data)
  }
}
